const TULIP_DOMAIN = "tulip.co";

const normalize = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";
const normalizeId = (value) =>
  typeof value === "string" ? value.trim() : "";

export const getEmailDomain = (email) => {
  console.log(email,"email");
  const normalizedEmail = normalize(email);
  const atIndex = normalizedEmail.lastIndexOf("@");
  if (atIndex < 0 || atIndex === normalizedEmail.length - 1) {
    return "";
  }
  console.log(normalizedEmail.slice(atIndex + 1),"domain");
  return normalizedEmail.slice(atIndex + 1);
};

export const getEmailUsername = (email) => {
  const normalizedEmail = normalize(email);
  const atIndex = normalizedEmail.lastIndexOf("@");
  if (atIndex <= 0) {
    return "";
  }
  return normalizedEmail.slice(0, atIndex);
};

const getEffectiveUserDomain = (userOrDomain) => {
  if (typeof userOrDomain === "string") {
    return normalize(userOrDomain);
  }

  const explicitDomain = normalize(userOrDomain?.domain);
  if (explicitDomain) {
    return explicitDomain;
  }

  return getEmailDomain(userOrDomain?.email);
};

const isOwnedByUser = (asset, user) => {
  if (!asset || !user) {
    return false;
  }

  const assetUserId = normalizeId(asset?.userid);
  const userId = normalizeId(user?.uid);
  if (assetUserId && userId && assetUserId === userId) {
    return true;
  }

  const assetEmail = normalize(asset?.email);
  const userEmail = normalize(user?.email);
  if (assetEmail && userEmail && assetEmail === userEmail) {
    return true;
  }

  // Last fallback for old records where uid may be missing.
  const assetDomain = getEmailDomain(asset?.email);
  const userDomain = getEffectiveUserDomain(user);
  const assetUsername = getEmailUsername(asset?.email);
  const userUsername = getEmailUsername(user?.email);
  return (
    Boolean(assetDomain) &&
    Boolean(userDomain) &&
    Boolean(assetUsername) &&
    Boolean(userUsername) &&
    assetDomain === userDomain &&
    assetUsername === userUsername
  );
};

export const isPartnerCreatedAsset = (asset) => {
  const creatorDomain = getEmailDomain(asset?.email);
  return Boolean(creatorDomain) && creatorDomain !== TULIP_DOMAIN;
};

export const hasMatchingPrivateDomain = (asset, userOrDomain) => {
  const assetPrivate = normalize(asset?.private);
  if (!assetPrivate) {
    return false;
  }

  const normalizedUserDomain = getEffectiveUserDomain(userOrDomain);
  if (!normalizedUserDomain) {
    return false;
  }

  const creatorDomain = getEmailDomain(asset?.email);

  // Accept both explicit share-key matching and creator-domain sharing.
  return (
    assetPrivate === normalizedUserDomain ||
    (Boolean(creatorDomain) && creatorDomain === normalizedUserDomain)
  );
};

export const canUserViewAsset = (asset, user) => {
  if (!asset || !user) {
    return false;
  }

  if (user.admin === true) {
    return true;
  }

  if (isOwnedByUser(asset, user)) {
    return true;
  }

  if (hasMatchingPrivateDomain(asset, user)) {
    return true;
  }

   // ✅ NEW: allow if asset creator domain matches user domain
  const assetDomain = getEmailDomain(asset?.email);
  const userDomain = getEffectiveUserDomain(user);

  if (
    Boolean(assetDomain) &&
    Boolean(userDomain) &&
    assetDomain === userDomain
  ) {
    return true;
  }

  if (isPartnerCreatedAsset(asset)) {
    return false;
  }

  // Preserve legacy behavior for Tulip/system-created assets.
  return !normalize(asset.private);
};
